<div class="border rounded-5 p-3 table-border-color text-xs">
  <div class="table-responsive">
    <table :id="table_id" class="table table-hover dt-responsive">
      <thead class="custom-header">
        <tr>
          <th v-for="header in headers" :key="header" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
            {{ header }}
          </th>
          <th v-if="$slots.actions" class="text-uppercase text-xxs font-weight-bolder opacity-7">
            Action
          </th>
          <th v-if="$slots.assign" class="text-uppercase text-xxs font-weight-bolder opacity-7 ">
            Assign
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="(!Array.isArray(data) || data.length === 0) && !isInitializing">
          <td :colspan="headers.length + ($slots.actions ? 1 : 0) + ($slots.assign ? 1 : 0)" class="text-xxs text-muted">
            No matching records available
          </td>
        </tr>
        <tr v-else v-for="(row, index) in data" :key="index">
          <td v-for="(value, key) in row" :key="key" class="text-xxs text-start">
            {{ value || value === 0 ? value : '-' }}
          </td>

          <td v-if="$slots.actions" class="text-start">
            <div class="d-flex gap-3">
              <slot name="actions" :row="row"></slot>
            </div>
          </td>
          <td v-if="$slots.assign" class="text-start">
            <div class="d-flex gap-3">
              <slot name="assign" :row="row"></slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
 